import Swiper from 'swiper/bundle';

export default () => {
  const latestPostsSlider = document.querySelector('.js-latest-post-swiper');
  if (latestPostsSlider) {
    new Swiper(latestPostsSlider, {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".js-latest-post-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="Swiper__PaginationItem ' + className + '">' + (index + 1) + "</span>";
        },
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });

  }
}